module.exports = __webpack_public_path__ + "img/model_19_zh.b6edb953.jpg";